import Typography from 'material-ui/styles/typography';
import MyRawTheme from 'styles/themes/ForceManagerTheme';

export default {
    contentPopup: {
        cursor: 'pointer',
        fontWeight: Typography.fontWeightLight,
        fontFamily: MyRawTheme.fontFamily,
        fontSize: 13,
        overflow: 'hidden',
        minWidth: 250,
        padding: '8px 0px',
    },
    textClick: {
        display: 'block',
        color: '#216db3',
        marginTop: 3,
        padding: '8px 16px 8px 16px',
    },
    popOver: {
        marginTop: 8,
        fontSize: 13,
        fontWeight: 300,
        fontFamily: 'Roboto, "Helvetica Neue", Helvetica, Arial, sans-serif',
        color: '#212121',
        letterSpacing: 0.5,
    },
};
